const CHUNK_LOAD_ERROR_MESSAGES = [
  'Loading chunk',
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'Unable to preload CSS for',
];

export const isChunkLoadError = (error: unknown): boolean =>
  error instanceof Error &&
  CHUNK_LOAD_ERROR_MESSAGES.some((message) => error.message.includes(message));
